module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/note_spelling"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTE ON SPELLING AND ORTHOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/abbreviations"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-n"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_01"
    }
  }, [_vm._v("1 Prelude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_02"
    }
  }, [_vm._v("2 Assembly: Logooli Historical, Cultural, and Musical Background")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Encounter: Avalogooli and Euro-American Religion, Culture, and Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Consolidation: Christian Religious Genres in Logooli-Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Accommodation: Logooli Adoption and Use of ‘Book’ Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Syncretism: Logooli Christian Songs of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Invocation: Logooli Christian Songs in Contemporary Education and Media")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-nb"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/appendix_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APPENDIX 1")]), _vm._v(". Archival and Media House Records")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/appendix_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APPENDIX 2")]), _vm._v(". Song Text and Hymn Tune Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GLOSSARY OF TERMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    staticClass: "none",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0